export default __webpack_public_path__ + "2f70b4a5ebba2cd011f793f9014bfde5.png";